<sdc-bo-dialog
  [headerTitle]="title"
  [styleClass]="['variant-prominent-title']"
  [attr.data-cy]="'user-modal-' + action()">
  <div class="flex content-wrapper">
    <div class="mt-6">
      <div class="input-line">
        <div>
          <span><b>Username</b> <span class="mandatory-asterisk">*</span></span>
        </div>
        @if (action() === actionsEnum.edit || action() === actionsEnum.create) {
          <div>
            <input
              [attr.data-cy]="'user-username-input'"
              type="text"
              [(ngModel)]="user.username"
              [class.invalid-input]="hashValidator.username" />
            @if (hashValidator.username) {
              <span class="text-[80%] error-color"
                >This entry is mandatory</span
              >
            }
          </div>
        }
        @if (action() === actionsEnum.delete) {
          <div>
            {{ user.username }}
          </div>
        }
      </div>

      @if (action() === actionsEnum.create || action() === actionsEnum.edit) {
        <div class="input-line">
          <div>
            <span class="password-title-container">
              <div class="password-help-container">
                <div>Must contain:</div>
                <div>- Minimum eight characters</div>
                <div>- At least one uppercase letter</div>
                <div>- At least one lowercase letter</div>
                <div>- At least one number</div>
                <div>- At least one special character ($!%*?&)</div>
              </div>
              <b>Password</b> <span class="mandatory-asterisk">*</span>
              <ng-icon
                name="lucideCircleHelp"
                class="password-help-icon"
                size="1em"></ng-icon>
            </span>
          </div>
          <div>
            <label for="user-password" class="password-container">
              <input
                [attr.data-cy]="'user-password-input'"
                id="user-password"
                [type]="passwordInputType"
                [(ngModel)]="user.password"
                [class.invalid-input]="hashValidator.password" />
              @if (passwordInputType === 'password') {
                <ng-icon
                  name="lucideEye"
                  size="1em"
                  (click)="togglePasswordInputType()"></ng-icon>
              }
              @if (passwordInputType === 'text') {
                <ng-icon
                  name="lucidePower"
                  size="1em"
                  (click)="togglePasswordInputType()"></ng-icon>
              }
            </label>
            @if (hashValidator.password) {
              <span class="text-[80%] error-color">This entry is invalid</span>
            }
          </div>
        </div>
      }

      @if (action() === actionsEnum.edit) {
        <div class="input-line">
          <div>
            <div>
              <span
                ><b>Confirm password</b>
                <span class="mandatory-asterisk">*</span></span
              >
            </div>
            <input
              id="confirm-password"
              [type]="passwordInputType"
              [(ngModel)]="confirmPassword.value"
              [class.invalid-input]="confirmPassword.hasError" />
            @if (confirmPassword.hasError) {
              <span class="text-[80%] error-color"
                >This entry not match the password</span
              >
            }
          </div>
        </div>
      }

      <div class="input-line">
        <div>
          <span><b>Email</b> <span class="mandatory-asterisk">*</span></span>
        </div>
        @if (action() === actionsEnum.edit || action() === actionsEnum.create) {
          <div>
            <input
              [attr.data-cy]="'user-email-input'"
              type="text"
              [(ngModel)]="user.email"
              [class.invalid-input]="hashValidator.email" />
            @if (hashValidator.email) {
              <span class="text-[80%] error-color">This entry is invalid</span>
            }
          </div>
        }
        @if (action() === actionsEnum.delete) {
          <div>
            {{ user.email }}
          </div>
        }
      </div>

      <div class="input-line">
        <div>
          <span><b>Type</b> <span class="mandatory-asterisk">*</span></span>
        </div>
        @if (action() === actionsEnum.edit || action() === actionsEnum.create) {
          <div>
            <select [(ngModel)]="user.type">
              @for (value of userTypes; track value) {
                <option [value]="value">
                  {{ value }}
                </option>
              }
            </select>
          </div>
        }

        @if (action() === actionsEnum.delete) {
          <div>
            <select disabled>
              <option>{{ user.type }}</option>
            </select>
          </div>
        }
      </div>
    </div>
  </div>
  <ng-container sdc-bo-dialog-footer>
    <sdc-button variant="secondary" (onClick)="onDismiss('cancel')">
      Cancel
    </sdc-button>
    <sdc-button
      [variant]="action() === actionsEnum.delete ? 'destructive' : 'primary'"
      (onClick)="onConfirm()"
      data-cy="user-confirm-button">
      {{ action() === actionsEnum.delete ? 'Permanently delete' : 'Save' }}
    </sdc-button>
  </ng-container>
</sdc-bo-dialog>
